import React from 'react'

import { useTenant } from '@rewardops/auth'
import { Button, buttonVariants, cn, LocalizedLink } from '@rewardops/ui'

interface Props extends React.HTMLAttributes<HTMLElement> {
  children: string
  href?: string
  className?: string
}

const defaultClasses =
  'top-5 m-auto mt-3 w-fit rounded-2xl px-5 py-1 text-lg text-white'

const nabClasses =
  'top-5 m-auto mt-3 w-fit px-5 py-1 text-lg text-white bg-tenant-primary-color text-white hover:bg-tenant-secondary-color'

const wjClasses =
  'top-5 m-auto mt-5 w-fit rounded-full bg-[#017F7C] hover:bg-[#1F4D49] tracking-[.2em] uppercase px-8 py-7 text-lg text-white'

const pawClasses =
  'top-5 m-auto mt-3 w-fit px-5 py-1 text-lg text-white bg-tenant-primary-color text-white hover:bg-tenant-secondary-color'

const AdButton = ({ href, children, className = '', ...props }: Props) => {
  const tenant = useTenant()

  // TODO: should be moved to tenant config
  const styleClasses =
    tenant.styleVariant?.title === 'maple-wj'
      ? wjClasses
      : tenant.styleVariant?.title === 'maple-nab'
      ? nabClasses
      : tenant?.styleVariant?.title === 'maple-points-at-work'
      ? pawClasses
      : defaultClasses

  const combinedClasses = `${styleClasses} ${className}`

  if (href) {
    return (
      <LocalizedLink
        href={href}
        className={cn(buttonVariants(), combinedClasses)}
        {...props}
      >
        {children}
      </LocalizedLink>
    )
  }

  return (
    <Button className={cn(combinedClasses)} {...props}>
      {children}
    </Button>
  )
}

export default AdButton
